import React from "react";
import "./AboutPositioning.css";

const positioningCards = [
  {
    id: "market",
    number: "01",
    title: "Market clarity",
    text: "Understand what price is doing and why it matters.",
  },
  {
    id: "process",
    number: "02",
    title: "Trade process",
    text: "Plan entries, exits and risk before the trade.",
  },
  {
    id: "review",
    number: "03",
    title: "Review habit",
    text: "Use feedback to make cleaner decisions.",
  },
];

function AboutPositioning() {
  return (
    <section
      className="trpc-aboutPositioning"
      aria-labelledby="trpc-aboutPositioning-title"
    >
      <div className="trpc-aboutPositioning-shell">
        <div className="trpc-aboutPositioning-grid">
          <div className="trpc-aboutPositioning-copy">
            <span className="trpc-aboutPositioning-kicker">Who We Are</span>

            <h2
              id="trpc-aboutPositioning-title"
              className="trpc-aboutPositioning-title"
            >
              We turn market noise into a clear trading process.
            </h2>

            <p className="trpc-aboutPositioning-text">
              Trade Performance Centre is a trading education company for people
              who want practical skill, not shortcuts.
            </p>
          </div>

          <div className="trpc-aboutPositioning-visual">
            <div className="trpc-aboutPositioning-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3592.8306643662054!2d28.266481675195706!3d-25.77615617734278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9560eebe6d1c1d%3A0x316b08c23680aaf9!2s13%20Umgazi%20Rd%2C%20Menlo%20Park%2C%20Pretoria%2C%200081!5e0!3m2!1sen!2sza!4v1779793564850!5m2!1sen!2sza"
                title="Trade Performance Centre — 13 Umgazi Rd, Menlo Park, Pretoria"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="trpc-aboutPositioning-beliefCard">
              <span>Core Belief</span>
              <strong>Structure creates confidence.</strong>
            </div>
          </div>
        </div>

        <div className="trpc-aboutPositioning-cards">
          {positioningCards.map((card) => (
            <article key={card.id} className="trpc-aboutPositioning-card">
              <span>{card.number}</span>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutPositioning;